import { render } from "./AssessmentDetails.vue?vue&type=template&id=1a7bb579&scoped=true"
import script from "./AssessmentDetails.vue?vue&type=script&lang=js"
export * from "./AssessmentDetails.vue?vue&type=script&lang=js"

import "./AssessmentDetails.vue?vue&type=style&index=0&id=1a7bb579&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a7bb579"]])

export default __exports__